import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageHeaderComponent } from '../../atoms/page-header/page-header.component';
import { InfoCardComponent } from '../../molecules/info-card/info-card.component';
import { LoaderWrapperComponent } from '../../atoms/loader-wrapper/loader-wrapper.component';
import { DeviceAlarmCard } from '../../molecules/device-alarm-card/device-alarm-card.component';
import { IconComponent } from '@ui';

@Component({
  selector: 'ui-alarms-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    PageHeaderComponent,
    InfoCardComponent,
    LoaderWrapperComponent,
    DeviceAlarmCard,
    IconComponent
  ],
  template: `
    <ng-container *transloco="let t">
      <ui-page-header [class]="'bg-red-3'">
        <div class="col-span-12">
          <div class="relative card-container flex flex-col h-full w-full">
            <div class="z-50 text-white py-2 flex flex-row gap-x-2 justify-center items-center">
              <ui-icon icon="calendar" />
              <span>{{ t('LAST_MONTH') }}</span>
            </div>
            <div class="z-50 grid grid-cols-12 sm:grid-cols-12 gap-4 h-full w-full">
              <div class="col-span-1 sm:col-span-3 xl:col-span-6">
                <ui-info-card
                  [title]="t('ALARMS.LABEL')"
                  icon="bell"
                  [iconClasses]="'text-red-500'"
                >
                </ui-info-card>
              </div>
              <div class="col-span-1 sm:col-span-4 xl:col-span-2">
                <ui-loader [loading]="loading()" loadingType="skeletonCard">
                  <ui-device-alarm-card
                    [icon]="'icons:remote'"
                    [label]="t('ALARMS.DEVICE_ALARM_CARD.RSABT')"
                    [count]="countRsabt()"
                  />
                </ui-loader>
              </div>
              <div class="col-span-1 sm:col-span-4 xl:col-span-2">
                <ui-loader [loading]="loading()" loadingType="skeletonCard">
                  <ui-device-alarm-card
                    [icon]="'icons:tsabt'"
                    [label]="t('ALARMS.DEVICE_ALARM_CARD.TSABT')"
                    [count]="countTsabt()"
                  />
                </ui-loader>
              </div>
              <div class="col-span-1 sm:col-span-4 xl:col-span-2">
                <ui-loader [loading]="loading()" loadingType="skeletonCard">
                  <ui-device-alarm-card
                    [icon]="'icons:vtn'"
                    [label]="t('ALARMS.DEVICE_ALARM_CARD.VTN')"
                    [count]="countVtn()"
                  />
                </ui-loader>
              </div>
            </div>
            <div class="z-10 rounded-t-lg bg-[#ff8686] absolute top-0 left-0 w-full h-[104px]"></div>
          </div>
        </div>
      </ui-page-header>
    </ng-container>
  `,
})
export class AlarmsHeaderComponent {
  countRsabt = input<number | null>(null);
  countTsabt = input<number | null>(null);
  countVtn = input<number | null>(null);
  loading = input<boolean>(true);
}
